import { render, staticRenderFns } from "./TruformeOption.vue?vue&type=template&id=38c0ef42&scoped=true"
import script from "./TruformeOption.vue?vue&type=script&lang=js"
export * from "./TruformeOption.vue?vue&type=script&lang=js"
import style0 from "./TruformeOption.vue?vue&type=style&index=0&id=38c0ef42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0ef42",
  null
  
)

export default component.exports